import React, { useState } from "react";
//import { Document, Page } from "react-pdf";
import ReactDOM from "react-dom";
import { pdfjs, Document, Page } from "react-pdf";
// import  "pdfjs-dist/es5/build/pdf.js"
// import "pdfjs-dist/es5/build/pdf.worker.js"
export default function AllPages(props) {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const { errorMessage, pdf } = props;
  
  return (
    <Document
      error={errorMessage}
      file={pdf}
      //options={{ workerSrc: "/pdf.worker.js" }}
      onLoadSuccess={onDocumentLoadSuccess}
      
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page scale={2.0}  key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false}/>
      ))}
    </Document>
//     <Document file={pdf}>
//     <Page pageNumber={1} />
//   </Document>

  );
}
